/*
 * @Author: 蛋蛋
 * @Date: 2020-12-21 16:14:33
 * @LastEditors: 脉迈
 * @LastEditTime: 2021-08-19 15:08:53
 */
import FN from './fn'
let ENV = 'prod'
let hostname = window.location.host.substring(window.location.host.indexOf('.'))
//  本地调试地址
if (hostname === '.hwx.com') hostname = '.neya.cc';
if (hostname === '.lcp.com') hostname = '.lcp-overseas.com';
if (/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(location.hostname)) ENV = 'local'
console.log(ENV)
const __postDomain = {
  local: '//' + location.host.slice(0, location.host.length - 5) + ':8080',
  dev: location.host,
  test: location.host,
  prod: location.host
}
const __gamepayDomain = {
  local: `pay.qianxi5.com`,
  dev: `pay${hostname}`,
  test: `pf-pay.${hostname}`,
  prod: `pf-pay.${hostname}`,
  get () {
    return `//${__gamepayDomain[ENV]}/`
  }
}

const __gameapiDomain = {
  local: `api.qianxi5.com`,
  dev: `api.${hostname}`,
  test: `pf-api.${hostname}`,
  prod: `pf-api.${hostname}`,
  get () {
    return `//${__gameapiDomain[ENV]}/`
  }
}
const __h5apiDomain = {
  jsLoad: {
    local: `yisdk-api.qianxi5.com`,
    dev: `yisdk-api${hostname}`,
    test: `rh-api${hostname}`,
    prod: `rh-api${hostname}`
  },
  paramsLoad: {
    local: `yisdk-api.qianxi5.com`,
    dev: `yisdk-api${hostname}`,
    test: `rh-api${hostname}`,
    prod: `rh-api${hostname}`
  },
  clientLoad: {
    local: `h5game.qianxi5.com`,
    dev: `h5game${hostname}`,
    test: `h5game${hostname}`,
    prod: `h5game${hostname}`
  },
  get (key) {
    return `//${__h5apiDomain[key][ENV]}/`
  }
}
const __fuseDomain = {
  init: {
    local: `yisdk-api.qianxi5.com`,
    dev: `yisdk-api${hostname}`,
    test: `rh-api${hostname}`,
    prod: `rh-api${hostname}`
  },
  role: {
    local: `yisdk-api.qianxi5.com`,
    dev: `yisdk-api${hostname}`,
    test: `rh-api${hostname}`,
    prod: `rh-api${hostname}`
  },
  pay: {
    local: `yisdk-api.qianxi5.com`,
    dev: `yisdk-api${hostname}`,
    test: `rh-api${hostname}`,
    prod: `rh-api${hostname}`
  },
  user: {
    local: `yisdk-api.qianxi5.com`,
    dev: `yisdk-api${hostname}`,
    test: `rh-api${hostname}`,
    prod: `rh-api${hostname}`
  },
  get (key) {
    return `//${__fuseDomain[key][ENV]}/`
  }
}
export default {
  __gameapiDomain,
  __postDomain,
  __fuseDomain,
  __h5apiDomain,
  __gamepayDomain
}
